import NarratorsController from './NarratorsController';

export { NarratorsController };
